import React, { memo } from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import SectionCardBase from './SectionCardBase';
import palette from '../../../styles/palette';

const useStyles = makeStyles(() => ({
  label: {
    color: palette.typography.white.high,
    fontSize: '0.75rem',
    lineHeight: '1rem',
    fontWeight: 'bold',
    minWidth: '5.188rem',
    textAlign: 'end',
    letterSpacing: '0rem',
    marginRight: '1.625rem',
  },
  value: {
    color: palette.typography.white.medium,
    fontSize: '0.75rem',
    lineHeight: '1rem',
    letterSpacing: '-0.02rem',
    marginRight: '1.625rem',
  },
  dataContainer: {
    display: 'flex',
  },
  container: {
    marginTop: '0.25rem',
    display: 'flex',
    flexDirection: 'column',
  },
  status: {
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    color: palette.typography.white.medium,
    marginLeft: '0.938rem',
  },
}));

const TotalSuffix = 'Total';
const PercentageSuffix = 'Percentage';
const Items = [
  {
    label: 'Departed',
    prefix: 'departed',
  },
  {
    label: 'Loading',
    prefix: 'loading',
  },
  {
    label: 'Downloaded',
    prefix: 'downloaded',
  },
  {
    label: 'Ready',
    prefix: 'ready',
  },
  {
    label: 'Open',
    prefix: 'open',
  },
  {
    label: 'In Build',
    prefix: 'inBuild',
  },
  {
    label: 'Offline',
    prefix: 'offline',
  },
];

const SectionFullCard = ({ routeStatus, ...section }) => {
  const styles = useStyles();

  return (
    <SectionCardBase {...section} className={styles.section}>
      <>
        <Typography className={styles.status}>Route Status</Typography>
        <Box className={styles.container}>
          {Items.map(({ label, prefix }) => (
            <Box key={label} className={styles.dataContainer}>
              <Typography
                className={styles.label}
                data-testid={`${prefix}-label`}
              >
                {label}
              </Typography>
              <Typography
                className={styles.value}
                data-testid={`${prefix}${TotalSuffix}`}
              >
                {`${routeStatus[`${prefix}${TotalSuffix}`]}`.padStart(3, 0)}
              </Typography>
              <Typography
                className={styles.value}
                data-testid={`${prefix}${PercentageSuffix}`}
              >
                {`${routeStatus[`${prefix}${PercentageSuffix}`]}%`.padStart(
                  4,
                  0
                )}
              </Typography>
            </Box>
          ))}
        </Box>
      </>
    </SectionCardBase>
  );
};

export default memo(SectionFullCard);
